import dayjs from "@/helpers/dayjs"

const ingoredKeys = [
	'deliverNow',
	'deliverTime',
];

export default function({ formData = {}, accountUserDetail, accountLastAddress, cartZip, form, $store, isDelivery = false}) {
	if (formData?.shippingAddress == null && accountUserDetail && accountUserDetail.email) {
		// if we are logged in, try to restore from account
		formData.email = accountUserDetail.email
		formData.shippingAddress = {
			firstName: accountUserDetail.firstName,
			lastName: accountUserDetail.lastName,
			phoneNumber: accountUserDetail.phoneNumber,
		}
		if (accountLastAddress && ((isDelivery && accountLastAddress.postcode == cartZip) || !isDelivery)) {
			formData.shippingAddress = {
				firstName: accountLastAddress.firstName,
				lastName: accountLastAddress.lastName,
				countryCode: accountLastAddress.countryCode,
				street: accountLastAddress.street,
				streetNumber: accountLastAddress.streetNumber,
				city: accountLastAddress.city,
				// Postcode must be a string, otherwise Sylius won't accept it
				postcode: accountLastAddress.postcode.toString(),
				provinceName: accountLastAddress.provinceName,
				company: accountLastAddress.company,
				phoneNumber: accountLastAddress.phoneNumber,
				details: accountLastAddress.details,
			}
		} else if (cartZip) {
			formData.shippingAddress = {
				// Postcode must be a string, otherwise Sylius won't accept it
				postcode: cartZip.toString()
			}
		}
	}
	else if (accountUserDetail && accountUserDetail.email) {
		if (!formData) {
			formData = {};
		}
		formData.email = accountUserDetail.email;
	}

	if (formData) {
		//the restore process will eventually be handled within vuex in the funture
		//prefill form
		for (var i in formData) {
			if (formData[i] == null) {
				continue
			}

			if (ingoredKeys.includes(i)) {
				// ignore these keys
			} else if (i == 'shippingAddress' || i == 'billingAddress') {
				let addr = formData[i]
				for (var j in addr) {
					let addrVal = addr[j]
					if (!form[i][j] && addrVal) {
						form[i][j] = addrVal
					}
				}
			} else {
				form[i] = formData[i]
			}
		}
	}

	if (isDelivery && cartZip) {
		form.shippingAddress.postcode = cartZip.toString();
	}
}
